import Vue from 'vue'
import Vuex from 'vuex'

import axios from '@/common/axios'

Vue.use(Vuex)

const ADD_STATES = 'ADD_STATES'
const ADD_CITIES = 'ADD_CITIES'
const ADD_STORES = 'ADD_STORES'
const ADD_PLACE_ID = 'ADD_PLACE_ID'

const UPDATE_STATES_VALUES = 'UPDATE_STATES_VALUES'
const UPDATE_CITIES_VALUES = 'UPDATE_CITIES_VALUES'
const UPDATE_STORES_VALUES = 'UPDATE_STORES_VALUES'

const REMOVE_STATES = 'REMOVE_STATES'
const REMOVE_CITIES = 'REMOVE_CITIES'
const REMOVE_STORES = 'REMOVE_STORES'

const REMOVE_PLACE_ID = 'REMOVE_PLACE_ID'
const REMOVE_STORE = 'REMOVE_STORE'

const multipleChainedSelect = {
    namespaced: true,
    state: {
        selectionState: {
            value: null,
            options: []
        },
        selectionCity: {
            value: null,
            options: []
        },
        selectionStore: {
            value: null,
            options: []
        },

        selectedStore: null,
        placeId: null
    },
    mutations: {
        ADD_STATES (state, data) {
            state.selectionState.options = data
        },
        ADD_CITIES (state, data) {
            state.selectionCity.options = data
        },
        ADD_STORES (state, data) {
            state.selectionStore.options = data
        },

        // Vuex binding actions
        UPDATE_STATES_VALUES (state, data) {
            state.selectionState.value = data
        },
        UPDATE_CITIES_VALUES (state, data) {
            state.selectionCity.value = data
        },
        UPDATE_STORES_VALUES (state, data) {
            state.selectionStore.value = data
        },

        REMOVE_STATES (state, data) {
            state.selectionState.value = null
            state.selectionState.options = []
        },
        REMOVE_CITIES (state, data) {
            state.selectionCity.value = null
            state.selectionCity.options = []
        },
        REMOVE_STORES (state, data) {
            state.selectionStore.value = null
            state.selectionStore.options = []
        },

        ADD_SELECTED_STORE (state, data) {
            state.selectedStore = data
        },

        ADD_PLACE_ID (state, data) {
            state.placeId = data
        },

        REMOVE_STORE (state) {
            state.selectedStore = null
        },

        REMOVE_PLACE_ID (state, data) {
            state.placeId = null
        },
    },
    getters: {
        selectionState (state) {
            return state.selectionState
        },
        selectionCity (state) {
            return state.selectionCity
        },
        selectionStore (state) {
            return state.selectionStore
        },

        selectedStore (state) {
            return state.selectedStore
        },

        placeId (state) {
            return state.placeId
        }
    },
    actions: {
        // API actions
        async getStates ({ dispatch, commit, getters, rootGetters }) {
            try {
                //let result = await axios.get('https://tsi-retail-locator-prod.herokuapp.com/api/states/?has_slot_tempur=Y')
                let result = await axios.get('https://prod.retaillocator.svc.tsiaws.com/api/states/?retailer=sleep%20outfitters&has_slot_tempur=Y')
                commit(ADD_STATES, result.data)
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        },
        async getCities ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //let result = await axios.get(`https://tsi-retail-locator-prod.herokuapp.com/api/states/${data.state}/cities/?has_slot_tempur=Y`)
                let result = await axios.get(`https://prod.retaillocator.svc.tsiaws.com/api/states/${data.state}/cities/?retailer=sleep%20outfitters&has_slot_tempur=Y`)
                commit(ADD_CITIES, result.data)
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        },
        async getStores ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //let result = await axios.get(`https://tsi-retail-locator-prod.herokuapp.com/api/states/${data.state}/cities/${data.city}/stores/?has_slot_tempur=Y`)
                //let result = await axios.get(`https://prod.retaillocator.svc.tsiaws.com/api/states/${data.state}/cities/${data.city}/stores/?retailer=sleep%20outfitters&has_slot_tempur=Y`)
                let result = await axios.get(`https://prod.retaillocator.svc.tsiaws.com/api/locations/?distance=50&format=json&q=${data.city},${data.state}&retailer=sleep%20outfitters`)
                commit(ADD_STORES, result.data)
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        },

        // Google Place Search
        async getPlaceId ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                let result = await axios.get(`/placeid?input=${data.selectedStore.name}, ${data.selectedStore.address}, ${data.selectedStore.city}, ${data.selectedStore.state} ${data.selectedStore.postal}`)
                //test
                //let result = JSON.parse('{"candidates" : [{"place_id" : "ChIJmz9MPrANiYgRg3hNUDnm-fQ"}],"status" : "OK"}')

                commit(ADD_PLACE_ID, result.data.candidates[0].place_id)
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        },

        // Non API actions
        async reset ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(REMOVE_STATES)
                commit(REMOVE_CITIES)
                commit(REMOVE_STORES)
                commit(REMOVE_STORE)
                commit(REMOVE_PLACE_ID)
                await dispatch('getStates')
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        },

        // Vuex binding actions
        async updateStatesValue ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                commit(UPDATE_STATES_VALUES, data)
                commit(REMOVE_CITIES)
                commit(REMOVE_STORES)
                commit(REMOVE_PLACE_ID)
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        },
        async updateCitiesValue ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                commit(UPDATE_CITIES_VALUES, data)
                commit(REMOVE_STORES)
                commit(REMOVE_PLACE_ID)
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        },
        async updateStoresValue ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                commit(UPDATE_STORES_VALUES, data)
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        }
    }
}

export default multipleChainedSelect
